import React from "react";
import { withTranslation } from "react-i18next";

class Schedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            apiUrl: window.axHours?.apiUrl || '',
            apiKey: window.axHours?.apiKey || '',
            error: null,
            isLoaded: false,
            hours: {}
        };
    }

    componentDidMount() {
        this.fetchHours();
    }

    setHours(hours) {
        this.setState({
            isLoaded: true,
            hours: hours,
        });
    }

    fetchHours() {
        const url = `${this.state.apiUrl}/adherent/information?adherentCode=${this.props.adherentCode}`;
        
        fetch(url, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'X-API-KEY': this.state.apiKey
            }
        })
        .then(response => response.json())
        .then(
            data => this.setHours(data.hours),
            error => this.setState({ isLoaded: true, error })
        );
    }

    renderDay(day) {
        const dayName = day[0];
        const dayData = day[1];
        let hours;
        let classes = "day-wrapper";

        // Vérifier si une exception existe
        if (dayData.exception) {
            // Cas 1: Exception avec fermeture
            if (dayData.exception.isOpen === false) {
                hours = this.props.t('closed');
                classes += " closed exception";
            }
            // Cas 2: Exception avec des horaires spécifiques
            else if (dayData.exception.isOpen === true && dayData.exception.hours) {
                classes += " exception";
                const scheduleParts = dayData.exception.hours.split(/\s*\/\s*/);
                if (scheduleParts.length === 2) {
                    hours = (
                        <div className="hours">
                            <span className="morning-hours">{scheduleParts[0]}</span>
                            <span className="afternoon-hours">{scheduleParts[1]}</span>
                        </div>
                    );
                } else {
                    hours = dayData.exception.hours.replace(/\s*\/\s*/g, ' | ');
                }
            }
            // Cas 3: Exception sans horaires mais ouvert (utiliser les horaires normaux)
            else {
                // Si l'exception n'a pas d'horaires mais isOpen est true, utiliser les horaires normaux
                if (dayData.schedule === 'closed') {
                    hours = this.props.t('closed');
                    classes += " closed";
                } else {
                    const scheduleParts = dayData.schedule.split(/\s*\/\s*/);
                    if (scheduleParts.length === 2) {
                        hours = (
                            <div className="hours">
                                <span className="morning-hours">{scheduleParts[0]}</span>
                                <span className="afternoon-hours">{scheduleParts[1]}</span>
                            </div>
                        );
                    } else {
                        hours = dayData.schedule.replace(/\s*\/\s*/g, ' | ');
                    }
                }
            }
        }
        // Pas d'exception, utiliser les horaires normaux
        else if (dayData.schedule === 'closed') {
            hours = this.props.t('closed');
            classes += " closed";
        } else {
            // Séparer les horaires matin et après-midi
            const scheduleParts = dayData.schedule.split(/\s*\/\s*/);
            if (scheduleParts.length === 2) {
                hours = (
                    <div className="hours">
                        <span className="morning-hours">{scheduleParts[0]}</span>
                        <span className="afternoon-hours">{scheduleParts[1]}</span>
                    </div>
                );
            } else {
                hours = dayData.schedule.replace(/\s*\/\s*/g, ' | ');
            }
        }

        return (
            <div key={dayName} className={classes}>
                <span className="day">
                    {this.props.t(dayName)}
                </span>
                {typeof hours === 'string' ? (
                    <span className="hours">
                        {hours}
                    </span>
                ) : (
                    hours
                )}
            </div>
        );
    }

    render() {
        const { error, isLoaded, hours } = this.state;

        if (error) {
            return (
                <div className="adherents-infos adherents-infos-hours">
                    <div className="adherents-infos-hours-wrapper">
                        <h2 className="h2">{this.props.t('schedules')}</h2>
                        <div className="error-message">
                            {this.props.t('error')}
                        </div>
                    </div>
                </div>
            );
        }

        if (!isLoaded) {
            return (
                <div>{this.props.t('loading')}</div>
            );
        }

		// Définir l'ordre correct des jours
		const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
			
		// Trier les jours selon l'ordre défini
		const sortedDays = dayOrder
			.filter(day => hours.hasOwnProperty(day)) // Ne garder que les jours qui existent dans les données
			.map(day => [day, hours[day]]); // Créer les paires [nom_jour, données_jour]

		const hoursList = sortedDays.map((day) =>
			this.renderDay(day)
		);

        return (
            <div className="adherents-infos adherents-infos-hours">
                <div className="adherents-infos-hours-wrapper">
                    <div className="title-hours">{this.props.t('schedules')}</div>
                    <div className="opening-hours">
                        {hoursList}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Schedule);
